module.exports = __webpack_public_path__ + "static/abilia-extraimg3-min-76244a5faff49d694f71e72008114e03.png";